module.exports = __webpack_public_path__ + "static/media/success_flag.e1f9d90c.svg";